import React from 'react';
import { DataTable, RowActions, EmptyValue, IdLink, type DataTableColumn } from '@/components/ui';
import { VehicleProfile } from '../../../types/Vehicle';

interface VehicleProfileListProps {
  profiles: VehicleProfile[];
  onEdit: (profile: VehicleProfile) => void;
  onDelete: (profileId: number) => void;
  canEdit: boolean;
  loading?: boolean;
}

// DataTable `fill`: the white card is the page's one scroll box, with a sticky header, the
// Inspection column pinned left and Actions pinned right (W-H5, W-M8).
const VehicleProfileList: React.FC<VehicleProfileListProps> = ({ profiles, onEdit, onDelete, canEdit, loading = false }) => {
  const columns: DataTableColumn<VehicleProfile>[] = [
    {
      key: 'inspection',
      header: 'Inspection',
      mobile: 'title',
      // V3-025 / ACT-01: the profile name is the link that opens it (when the user can edit it).
      cell: (p) => (canEdit ? <IdLink onClick={() => onEdit(p)}>{p.inspection}</IdLink> : p.inspection),
    },
    { key: 'vehicleType', header: 'Vehicle Type', cell: (p) => p.vehicleType || <EmptyValue /> },
    {
      key: 'vehicleClassification',
      header: 'Vehicle Classification',
      cell: (p) => p.vehicleClassification || <EmptyValue />,
    },
    { key: 'pmClassification', header: 'PM Classification', cell: (p) => p.pmClassification || <EmptyValue /> },
    {
      key: 'actions',
      header: 'Actions',
      hidden: !canEdit,
      width: '5rem',
      align: 'right',
      mobile: 'trailing',
      cell: (p) => (
        <RowActions
          actions={[
            { kind: 'edit', label: 'Edit Profile', onClick: () => onEdit(p) },
            { kind: 'delete', label: 'Delete Profile', onClick: () => onDelete(p.id) },
          ]}
        />
      ),
    },
  ];

  return (
    <DataTable
      fill
      striped
      columns={columns}
      data={profiles}
      rowKey={(p) => p.id}
      loading={loading}
      emptyMessage={loading ? 'Loading vehicle profiles...' : 'No profiles available. Create one to get started.'}
    />
  );
};

export default VehicleProfileList;
